<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Documents">
                                <a-select mode="multiple" v-model="inputDocuments" showSearch placeholder="All Documents" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in documentOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Search Items (Barcode)">
                                <a-select mode="multiple" v-model="inputBarcode" style="width: 100%" placeholder="All Items" :filterOption="false" 
                                @select="(e) => {selectItem(e, 'product')}" 
                                @deselect="(e)=>{updateFilterList(e, 'product', 'delete')}" 
                                :notFoundContent="fetching ? undefined : null" @search="handleSearchProduct" >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                <a-select-option v-for="option in productOptions" :key="option.id" :value="option.id">{{option.barcode}} - {{option.name}}
                                </a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Group By">
                                <a-select v-model="inputGroupBy" showSearch optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in groupOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" csv-title="Unposted_Documents_Report">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" name="Unposted_Documents_Report" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'document_date',
                groupOptions: [
                    {key: 'document_date', value: 'Document Date'},
                    {key: 'document_no', value: 'Document No'},
                    {key: 'document_type', value: 'Document Type'},
                    {key: 'site_id', value: 'Document Site'},
                    {key: 'product', value: 'Product Id'},
                ],
                fetching: false,
                inputSite: [],
                inputDocuments: [],
                inputBarcode: [],
                productOptions: [],
                selectedProducts: [],
                site_type: "ho",
                siteOptions: [],
                documentOptions: [],
                inputSortBy: 'grouper_id',
                birSalesReports: [],
                inputLocation: [],
                locationOptions: [],
                showSortInfo: 'asc',
                JsonData: [],
                inputBrand: null,
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            //Start get valid Document Types
            var documents = await HTTPRequest.getRequest(component_x.endPoint + "document_types/get_valid_document_types?field_name=table_prefix&field_value=inventory", null);
            component_x.documentOptions = documents;
            //component_x.sort(component_x.documentOptions);
            //End get valid Document Types

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['endPoint', 'categoriesOptions']),
        },
        components:{
            VueJsonToCsv
        },
        watch: {
            isVatBreakdown: function() {
                if(this.isVatBreakdown == true){
                    this.isPercent = true
                    this.isNetReturn = false
                    this.isDiscount = false
                }
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            selectItem(id, source, f) {
            let selectedOption = {}
                if (source === 'product') {
                    selectedOption = this.productOptions.filter((item) => id === item.id)
                    if (this.selectedSuppliers.length === 0) {
                    this.selectedSuppliers.push(...selectedOption)
                    } else {
                    let isExisting = this.selectedSuppliers.filter((listedItem) => id === listedItem.id)
                    if (isExisting.length === 0) {
                        this.selectedSuppliers = [...this.selectedSuppliers, ...selectedOption]
                    }
                    }
                }
            },
            updateFilterList(e, source) {
                if (source === 'product') {
                    this.selectedProducts = this.selectedProducts.filter(({ id }) => id !== e)
                }
            },
            async handleSearchProduct(value) {
                if(value.length > 3){
                    this.fetching = true;
                    var products = await HTTPRequest.getRequest(this.endPoint + "products/search_product?search_value=" + value + "&field_name=barcode", null,
                    null)
                    this.productOptions = products
                    this.sort(this.productOptions)
                    this.fetching = false;
                }
            },
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            showFixed(num, fixed) {
                fixed = fixed || 0;
                fixed = Math.pow(10, fixed);
                return Math.floor(num * fixed) / fixed;
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "document": this.inputDocuments.toString(),
                    "product": this.inputBarcode.toString(),
                    "order_by": this.inputGroupBy
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'unposted_documents_report?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                
                let siteSpecific = get_request;
            
                if(get_request.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }
                    let headers = [];
                    headers = [
                            [
                                {content: 'Doc. Date', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Doc. No', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Doc. Type', styles: {halign: 'left', valign: 'left'}},
                                {content: 'Site Name', styles: {halign: 'left', valign: 'left'}},
                                {content: 'Barcode', styles: {halign: 'left', valign: 'left'}},
                                {content: 'Product Name', styles: {halign: 'left', valign: 'left'}},
                                {content: 'Quantity', styles: {halign: 'right', valign: 'right'}},
                                {content: 'Status', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_quantity = 0
                            let grand_total_quantity = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                if(grouper == 'start'){
                                    let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: group_text + ' : ' + grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                    let detail = [
                                        {content: reportLine.document_date, styles: {halign: 'center'}},
                                        {content: reportLine.document_no, styles: {halign: 'center'}},
                                        {content: reportLine.document_type, styles: {halign: 'left'}},
                                        {content: reportLine.site_name, styles: {halign: 'left'}},
                                        {content: reportLine.barcode, styles: {halign: 'left'}},
                                        {content: reportLine.product_name, styles: {halign: 'left'}},
                                        {content: reportLine.quantity, styles: {halign: 'right'}},
                                        {content: reportLine.document_status, styles: {halign: 'center'}}
                                    ]
                                  
                                sub_total_quantity += Number(reportLine.quantity)
                                grand_total_quantity += Number(reportLine.quantity)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal Qty:', sub_total_quantity,'']));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', '', '', '', 'Grand Total Qty:', grand_total_quantity,''
                                        ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', '', '', '', 'Subtotal Qty:', sub_total_quantity,'']));

                                        sub_total_quantity = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Unposted Documents Report By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                            doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 25},
                            1: {cellWidth: 20},
                            2: {cellWidth: 40},
                            3: {cellWidth: 50},
                            4: {cellWidth: 45},
                            5: {cellWidth: 100},
                            6: {cellWidth: 20},
                            7: {cellWidth: 25}
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    }

                    let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                    let pageCount = doc.internal.getNumberOfPages();

                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Unposted Documents Report By " + group_text, 340, 205, i, pageCount)
                    }
                        
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "document": this.inputDocuments.toString(),
                    "product": this.inputBarcode.toString(),
                    "order_by": this.inputGroupBy
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'unposted_documents_report?', parameters);
                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ['Doc. Date',' Doc. No',' Doc. Type',' Site Name',' Barcode',' Product Name',' Quantity',' Status'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_quantity = 0
                            let grand_total_quantity = 0
                        
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                let detail = [
                                    reportLine.document_date,
                                    Number(reportLine.document_no),
                                    String(reportLine.document_type),
                                    String(reportLine.site_name),
                                    String(reportLine.barcode),
                                    String(reportLine.product_name),
                                    Number(reportLine.quantity),
                                    String(reportLine.document_status)
                                ]
                                reportData.push(Object.assign({}, detail))
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push(["Unposted Documents Report By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
